import { useModalActions } from 'components/ModalManager/Context';
import { useCallback } from 'react';
import { AutoRechargeModal } from '../AutoRecharge/AutoRechargeModal';

type Props = {
  onSuccess?: () => void;
  onCloseCb?: () => void;
};
const MODAL_ID = 'auto_recharge_dialog';

export const useAutoRechargeModal = ({ onSuccess, onCloseCb }: Props = {}) => {
  const { openModal, closeModal } = useModalActions();

  const onClose = (): void => {
    closeModal({ id: MODAL_ID });
    onCloseCb?.();
  };

  const handleConfirm = useCallback((): void => {
    onSuccess?.();
    closeModal({ id: MODAL_ID });
  }, [onSuccess, closeModal]);

  return useCallback(() => {
    return openModal({
      id: MODAL_ID,
      title: '',
      content: <AutoRechargeModal onConfirm={handleConfirm} onClose={onClose} />,
      makeActions: () => null,
      onClose: () => closeModal({ id: MODAL_ID }),
    });
  }, [openModal, onClose]);
};
